import React, { Component } from 'react';

export class FstyrSegment extends Component {

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className='fstyr-page-segment'
        style={{ width: window.width, padding: 30 }}>
        <div className="row justify-content-center">
          <div className="col-sm-12 col-md-10 col-lg-8 col-xl-7">
            <p
              className="fstyr-page-header-text fstyr-primary-blue"
              style={{ marginBottom: 0, fontSize: this.props.isPageTitle ? "larger" : "medium" }}
            >
              {this.props.title}
            </p>
            {!this.props.isPageTitle &&
              <div className="fstyr-page-segment-line"/>
            }
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}